import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, ResolveEnd, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  private router: Router = inject(Router);

  public routeResolver = (activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => of({activatedRoute, state}).pipe(
    // tap((state) => console.log('routeResolver state.activatedRoute', state.activatedRoute)),
    // tap((state) => console.log('routeResolver state.state', state.state)),
    map(() => true),
    take(1)
  );

  public url$ = this.router.events.pipe(
    // tap((event) => console.log('RouteService router event.type', event.type)),
    // tap((event) => console.log('RouteService router event', event)),
    filter((event): event is ResolveEnd => (event instanceof ResolveEnd)),
    map((event) => event.urlAfterRedirects),
    // tap((url) => console.log('RouteService router url', url)),
  );
}

